module.exports = __webpack_public_path__ + "static/img/Qiotpro.0901343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/Qiotpro.png
// module id = 651
// module chunks = 1